//Helpers
import { translateTemplateTitle } from '../template_helpers';
//Types
import type { VirtualComponentInterfaceData, VCInterfaceStatus } from 'src/types/VirtualComponents';
import { convertToUnit } from '../../units_helpers';

/**
 * Updates a dehumidifier status interface based on the given data.
 * https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/2959
 *
 * @param {VCInterfaceStatus[]} interface_data - The interface data to be updated.
 * @param {VCInterfaceStatus} data - The interface data to be processed.
 * @param {VirtualComponentInterfaceData} valueData - The value data to be processed.
 */
export const updateDehumidifierStatus = (
	interface_data: VCInterfaceStatus[],
	data: VCInterfaceStatus,
	valueData: VirtualComponentInterfaceData,
): void => {
	const { role, config } = data;
	const childLock = /^(child_lock)$/.test(role);
	let hideLabel = !/^(target_humidity|current_humidity)$/.test(role);
	if (/^(target_humidity)$/.test(role)) {
		data.min = config.min;
		data.max = config.max;
		data.step = config?.meta?.ui?.step;
	} else if (childLock && valueData.value) {
		data.icon = 'far fa-lock';
		data.iconColor = '--color-danger';
		hideLabel = false;
	}
	interface_data.push({
		...data,
		hasAction: /^(enable)$/.test(role),
		event: valueData.event !== null ? valueData.event : valueData.value,
		value: childLock
			? null
			: translateTemplateTitle(valueData.label) ||
				convertToUnit(valueData.value, valueData.unit || ''),
		hideLabel,
	});
};
